module.exports = __webpack_public_path__ + "img/userdefault.0b469097.png";